import { useState } from "react";
import JsonLd from "@/components/feature/JsonLd";
import { getSiteSchema } from "@/seo/schema";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import WhatIsSection from "./components/WhatIsSection";
import FeaturesSection from "./components/FeaturesSection";
import PillarArticlesSection from "./components/PillarArticlesSection";
import ArticleCtaSection from "./components/ArticleCtaSection";
import FaqSection from "./components/FaqSection";
import FinalCtaSection from "./components/FinalCtaSection";

export default function Home() {
  const [query, setQuery] = useState("");

  return (
    <>
      <JsonLd data={getSiteSchema()} />
      <Navbar />
      <main className="pt-16">
        <Hero query={query} onQueryChange={setQuery} />
        <CategorySection query={query} />
        <WhatIsSection />
        <FeaturesSection />
        <PillarArticlesSection />
        <ArticleCtaSection />
        <FaqSection />
        <FinalCtaSection />
      </main>
      <Footer />
    </>
  );
}